<template>
  <b-card>Hello World SignUp!</b-card>
</template>

<script>
export default {

};
</script>
